import {elementiRMLSelezionatiApi} from "@commons/features/lavoratore/elemitiRMLSelezionati.api";
import {ElementoRMLXSelezioneByAziendaApi} from "@commons/features/PVA/RML/elementoRMLXSelezione.api";
import {RMLLavoratorePVAApi} from "@commons/features/PVA/RML/lavoratoreXSelezione.api";
import {PVAFilterApi} from "@commons/features/PVA/RML/PVAFilter.api";

export const PVAReducers = {
    [elementiRMLSelezionatiApi.reducerPath]: elementiRMLSelezionatiApi.reducer,
    [ElementoRMLXSelezioneByAziendaApi.reducerPath]: ElementoRMLXSelezioneByAziendaApi.reducer,

    [PVAFilterApi.reducerPath]: PVAFilterApi.reducer,
    [RMLLavoratorePVAApi.reducerPath]: RMLLavoratorePVAApi.reducer,
}
export const PVAMiddlewares = [
    elementiRMLSelezionatiApi.middleware,
    ElementoRMLXSelezioneByAziendaApi.middleware,

    PVAFilterApi.middleware,
    RMLLavoratorePVAApi.middleware,
]